import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SubscriptionAccessApiService } from './subscription-access-api.service';

export const EMPLOYEE_OVER_LIMIT = 'EMPLOYEE_OVER_LIMIT';

export type AppAccessDeniedReason = 'employeeOverLimit' | 'appNotGranted';

export interface AppAccessDecision {
  hasAccess: boolean;
  reason?: AppAccessDeniedReason;
}

/**
 * Egzekucja dostępu do aplikacji po /me/access.
 * Keycloak nie zna subskrypcji — sesja zostaje, UI pokazuje ekran blokady.
 */
@Injectable({
  providedIn: 'root',
})
export class AppAccessService {
  private readonly api = inject(SubscriptionAccessApiService);

  /** Błąd API nie może zablokować panelu — brak odpowiedzi = dostęp (fail-open). */
  resolveAccess(appCode: string): Observable<AppAccessDecision> {
    return this.api.getMeAccess().pipe(
      map(access => {
        if (!access) {
          return { hasAccess: true };
        }
        if (access.access_blocked_reason === EMPLOYEE_OVER_LIMIT) {
          return { hasAccess: false, reason: 'employeeOverLimit' };
        }
        const app = access.apps?.find(item => item.app_code === appCode);
        if (app?.is_active === true) {
          return { hasAccess: true };
        }
        return { hasAccess: false, reason: 'appNotGranted' };
      }),
    );
  }
}
